// Phase F.3 — Send-outs API hooks
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSendOuts = (logisticsRequestId) =>
  useQuery({
    queryKey: ["send-outs", logisticsRequestId],
    queryFn: () =>
      axios.get(`${API}/send-outs`, { params: { logistics_request_id: logisticsRequestId } })
        .then((r) => r.data),
    enabled: !!logisticsRequestId,
  });

export const useRecentSendOuts = (logisticsRequestId, limit = 3) =>
  useQuery({
    queryKey: ["send-outs-recent", logisticsRequestId, limit],
    queryFn: () =>
      axios.get(`${API}/send-outs/recent`, {
        params: { logistics_request_id: logisticsRequestId, limit },
      }).then((r) => r.data),
    enabled: !!logisticsRequestId,
  });

export const useCreateSendOut = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => axios.post(`${API}/send-outs`, body).then((r) => r.data),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: ["send-outs", vars.logistics_request_id] });
      qc.invalidateQueries({ queryKey: ["send-outs-recent", vars.logistics_request_id] });
    },
  });
};
